import { ReactElement } from 'react';
import { DotComponent, DotGroupContainer } from './styles';

interface DotProps {
  onClickDot: () => void;
  active: boolean;
}

export function Dot({
  onClickDot,
  active,
}: DotProps): ReactElement {
  return (
    <DotComponent
      active={active}
      type="button"
      onClick={onClickDot}
    />
  );
}

interface DotGroupProps {
  numberDots: number;
  selectedIndex: number;
  onDotClick: (index: number) => void;
}

export function DotGroup({
  numberDots,
  selectedIndex,
  onDotClick,
}: DotGroupProps): ReactElement {
  return (
    <DotGroupContainer>
      {Array.from({ length: numberDots }).map((_, index) => (
        <Dot
          key={index}
          onClickDot={() => onDotClick(index)}
          active={index === selectedIndex}
        />
      ))}
    </DotGroupContainer>
  );
}
